import React, { useContext, useEffect, useRef, useState } from 'react';

import EnvironmentContext from '../../../contexts/EnvironmentContext';

import { TListingClient } from 'types/TListing';
import { TFeedItem } from 'types/TFeeds';
import getFranchiseDealerItems from '../../../repositories/getFranchiseDealerItems';

type TProps = {
  listing: TListingClient;
};

let FranchiseDealerItemList;

const FranchiseDealerItemsLazy = ({ listing }: TProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState<TFeedItem[]>([]);
  const [itemsCount, setItemsCount] = useState(0);

  const { itemId } = listing;

  const {
    userDetails: {
      location: { postcode },
    },
  } = useContext(EnvironmentContext);

  useEffect(() => {
    const elementRef = containerRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          (async () => {
            try {
              const [dealersListData, dealersItemListChunk] = await Promise.all([
                getFranchiseDealerItems({
                  itemId: String(itemId),
                  postcode,
                }),
                import(
                  /* webpackChunkName: "FranchiseDealerItemList" */ '../../../components/FranchiseDealerItemList/FranchiseDealerItemList'
                ),
              ]);
              if (dealersListData.items.length) {
                setItems(dealersListData.items);
                setItemsCount(dealersListData.total ?? dealersListData.items.length);
                FranchiseDealerItemList = dealersItemListChunk.default;
                setIsLoaded(true);
              }
            } catch {}
          })();
        });
      },
      { rootMargin: '0px 0px 400px 0px' },
    );

    if (elementRef) observer.observe(elementRef);

    return () => {
      if (elementRef) observer.disconnect();
    };
  }, [itemId, postcode]);
  const ready = isLoaded && items?.length > 0 && FranchiseDealerItemList;

  if (!ready) {
    return <div ref={containerRef} style={{ width: 0, height: 0, overflow: 'hidden' }} aria-hidden />;
  }

  return (
    <div className="FranchiseDealerItemsContainer hz-Page-section hz-Page-section--separated" ref={containerRef}>
      {isLoaded && <FranchiseDealerItemList items={items} totalItemsCount={itemsCount} />}
    </div>
  );
};

export default FranchiseDealerItemsLazy;
